module.exports = __webpack_public_path__ + "static/media/grph-stat2-68.baed2a61.svg";